export const dateFormat = (date) => {
    let dateObject = convertStringToDate(date);
    let locale = (navigator.language || navigator.userLanguage).substring(0, 5);
    const formattedDate = new Intl.DateTimeFormat(locale ?? 'en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    }).format(dateObject);
    return formattedDate;
}

export const shortDateFormat = (date) => {
    let dateObject = convertStringToDate(date);
    let locale = (navigator.language || navigator.userLanguage).substring(0, 5);
    const formattedDate = new Intl.DateTimeFormat(locale ?? 'en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    }).format(dateObject);
    return formattedDate;
}

const convertStringToDate = (dateString) => {
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day);
}

export const decimalFormat = (decimal) => {
    if(decimal === undefined) return;
    return parseFloat(decimal).toFixed(2);
}

export const percentFormat = (percent) => {
    if(percent === undefined) return;
    return (percent * 100).toFixed(2) + '%';
}

export const capitalize = (text) => {
    if(text === undefined) return '';
    var words = text.split(' ');
    for(var i = 0; i < words.length; i++){
        words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
    }
    return words.join(' ');
}

export const onlyAllowNumbers = (e) => !/[0-9]/.test(e.key) ? e.preventDefault() : null;
